<!-- Messenger Plugin chat Code -->
<template>
  <div
    v-if="settingData"
    class="col-md-12"
  >
    <div
      class="zalo-chat-widget"
      :data-oaid="settingData.app.zalo_chat_enable == 1 ? settingData.app.zalo_chat : ''"
      data-welcome-message="Rất vui khi được hỗ trợ bạn!"
      data-autopopup="0"
      data-width=""
      data-height=""
    />

  </div>
  <!-- data-oaid="2253252695634181842" -->
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';

export default {
  props: {
    setting: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://sp.zalo.me/plugins/sdk.js')
    document.head.appendChild(recaptchaScript)
  },
  setup(props, context) {
    // const data = props.setting
    // const data = store.state.app.settings; console.log('zalo', data)
    // const { zalo_chat_enable, zalo_chat } = data.app
    // console.log(zalo_chat_enable)
    const settingData = computed({
      // getter
      get() {
        return store.state.app.settings
      },
      // setter
      set() {
      },
    })
    return {
      settingData,
    }
  },
}
</script>
<style lang="scss">
.za-chat__head-box {
    height: 50px !important;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    position: absolute;
    bottom: 6px !important;
    right: 5px !important;
}
</style>
